@use "/src/styles/functions";
@use "/src/styles/mixins";

$time: 0.3s;

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all $time ease-in-out;
  padding: 0;

  @include mixins.respond(xs) {
    padding: 0;
    align-items: flex-end;
  }

  & > div {
    max-width: 50rem;
    width: 100%;
  }
}

.backdrop {
  background: var(--color-alpha-colors-black-alpha-24);
  backdrop-filter: blur(6px);
  transition: all $time ease-in-out;
}

.modal {
  width: 100%;
  overflow: hidden;
  border-radius: functions.radius(20);
}

.anim {
  animation: modalAnim $time ease-in-out;
}

.exitAnim {
  animation: modalExitAnim $time ease-in-out;
}

$anim-distance: 2000px;
$anim-scale-x: 0.1;
$anim-scale-y: 0.3;

@keyframes modalAnim {
  0% {
    opacity: 0;
    //transform: translatey($anim-distance);
    scale: 0;
  }

  100% {
    opacity: 1;
    //transform: translatey(0);
    scale: 1;
  }
}

@keyframes modalExitAnim {
  0% {
    opacity: 1;
    //transform: translatey(0);
    scale: 1;
  }

  100% {
    opacity: 0;
    //transform: translatey($anim-distance);
    scale: 0;
  }
}

.radius {
  @include mixins.respond(xs) {
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}

.scrollContainer {
  width: 100%;
  height: 100%;

  max-height: 90dvh;
  overflow-y: auto;
}

.displayNone {
  display: none;
}
